var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CLOSE",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #CLOSE .cls-1 {\n        fill: #ff7600;\n      }\n\n      #CLOSE .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-width: 2px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pfd_CLOSE",
    transform: "translate(-311 -316)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    className: "cls-1",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(311 316)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_17",
    "data-name": "Linie 17",
    className: "cls-2",
    x1: 16.971,
    transform: "translate(317.161 333.661) rotate(-45)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linie_18",
    "data-name": "Linie 18",
    className: "cls-2",
    x1: 16.971,
    transform: "translate(317.161 321.661) rotate(45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.cbd9b2015866551796c163594ea8b31b.svg";
export { ForwardRef as ReactComponent };